<template>
  <v-container class="d-flex justify-center">
    <v-card flat class="notification-page notification-dialog">
      <h1>{{ $t('notifications.name') }}</h1>
      <NotificationList @clickNote="$events.fire('readNote', arguments[0])"/>
    </v-card>
  </v-container>
</template>

<script>
import API from '@/services/api'
import {mapGetters, mapActions} from 'vuex'
import {NotificationMixin} from '@/components/mixins'
import NotificationList from '@/components/Notifications/NotificationList'

// @group Notifications
// Notification-Notifications component
export default {
  name: 'Notifications',

  components: {
    NotificationList
  },

  props: {
    loadTime: Number
  },

  mixins: [NotificationMixin],

  created() {
    console.log('Notifications - created')
  },

  mounted() {
    console.log('Notifications - mounted')
  },

  computed: {
    ...mapGetters('currentuser', ['isLoggedIn', 'notifications']),
    ...mapGetters('app', ['isInitialized'])
  },

  methods: {
    ...mapActions('currentuser', ['setNotifications']),

    readNotifications() {
      if (this.isLoggedIn && this.isInitialized) {
        API.readNotifications({data: {}})
          .then(response => {
            this.loadNotifications()
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
      }
    },

    loadNotifications() {
      console.log('Notifications - loadNotifications')
      API.listNotifications({
        startAt: 0,
        pageSize: 1000,
        sortBy: 'sentTime',
        sortDesc: true,
        search: ''
      })
        .then(response => {
          this.setNotifications(response.data.rows)
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style>
</style>